import React, { FC, useCallback } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { Link } from '@mui/material';

import { useMediaSwitch, Stack } from 'Modules/ui3';

import { routes } from '../../../../routes/routes';


interface Links {
    links: string[];
}


const scrollWithOffset = (el, offset) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = offset;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};


export const Links: FC<Links> = ({ links }) => {
    const scrollOffset = useMediaSwitch(-112, -76, -60);

    const scrollCallback = useCallback(
        el => scrollWithOffset(el, scrollOffset),
        [scrollOffset],
    );

    const linkVariant = useMediaSwitch('regularBody2', 'regularBody2', 'regularCaption1');

    return (
        <Stack width={useMediaSwitch('100%', '208px', '151px')} justifyContent='space-between'>
            {links.map(key => routes.home.anchors[key])
                .map(({ route, name }) => (
                    <Link
                        key={route}
                        // @ts-ignore
                        component={NavHashLink}
                        to={`/${route}`}
                        exact
                        smooth
                        scroll={scrollCallback}
                        underline='none'
                        variant={linkVariant}
                        sx={{
                            '&:visited': {
                                color: 'grayscale.shade95',
                            },
                        }}
                    >
                        {name}
                    </Link>
                ))}
        </Stack>
    );
};
